export default __webpack_public_path__ + "static/media/IMG_1870 copie.74c484b6.jpg";